<template>
  <b-form-group :label-class='labelclass' :label="label" :class="`${classFormGroupBind} b-form-group-styled`" :invalid-feedback="invalidFeedback"
    :description="!error || !error.$error ? description : ''" :state="error && error.$error ? false : null">
    <datepicker :disabled='disabled' :value="selected" @input="handleInput" v-bind="$attrs" :type="typeDatepicker" :format="format"
      :placeholder="placeholder" lang="pt-br" class="b-form-date-styled"
      :input-attr="{ state: error && error.$error ? false : null }" />
  </b-form-group>
</template>

<script>
import Datepicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/pt-br"

export default {
  components: { Datepicker },
  props: {
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    labelclass: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: String,
    value: [Date, String],
    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "Digite um valor válido",
    },
    error: {
      type: Object,
      default: null,
    },
    typeDatepicker: {
      type: String,
      default: "date",
    },
  },
  data() {
    return {
      format: "DD/MM/YYYY",
      placeholder: "dd/mm/aaaa",
    }
  },
  computed: {
    selected() {
      if (!this.value) return null
      const dateParts = this.value.split('-')
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2])
    },
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
        (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
        (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 "
      return `${responsiveCols} ${this.classFormGroup}`
    },
  },
  methods: {
    handleInput(value) {
      if (value) {
        const date = new Date(value.getFullYear(), value.getMonth(), value.getDate())
        this.$emit('input', date.toISOString().split('T')[0])
      } else {
        this.$emit('input', null)
      }
    }
  },
  async mounted() {
    if (this.typeDatepicker === "datetime") {
      this.format += " hh:mm:ss"
      this.placeholder += " hh:mm:ss"
    }
  },
}
</script>

<style scoped>
.b-form-group-styled {
  font-size: 12px;
}

.b-form-date-styled {
  width: auto !important;
}

.b-form-date-input-styled input {
  height: 20px;
}
</style>
